import React from 'react';
import './style.scss';

const TableRowColumn = ({ className, children }) => (
  <div className={`table-row-column ${className || ''}`}>{[children]}</div>
);

export default TableRowColumn;



// WEBPACK FOOTER //
// ./src/components/Table/TableRowColumn/index.jsx